import React from "react";

export const SortHeader = ({ field, label, sort, direction, onSort }) => (
  <th aria-sort={sort === field ? (direction === "ASC" ? "ascending" : "descending") : "none"}>
    <button type="button" onClick={() => onSort(field)}>
      {label} <i className={`ti ${sort !== field ? "ti-arrows-sort" : direction === "ASC" ? "ti-sort-ascending" : "ti-sort-descending"}`} aria-hidden="true" />
    </button>
  </th>
);

export const pageWindow = (page, totalPages) => {
  const pages = new Set([1, totalPages, page - 1, page, page + 1].filter((value) => value >= 1 && value <= totalPages));
  const sorted = [...pages].sort((left, right) => left - right);
  return sorted.flatMap((value, index) => (index && value - sorted[index - 1] > 1 ? ["gap", value] : [value]));
};
